import React, {forwardRef, useState} from "react";
import { useTranslation } from "react-i18next";
import nextIcon from "../assets/next_icon.png";
import previousIcon from "../assets/previous_icon.png";
import classes from "./PageWrapper.module.css";
import BackToDashboard from "./BackToDashboard";
import useLanguage from "../utils/useLanguage";



const PageWrapper = forwardRef(({ withBackButton, title, children }, ref) => {
  const { t } = useTranslation("general");
  const { currentDirection } = useLanguage();


  return (
    <div ref={ref} className="e-container">
        {withBackButton && <BackToDashboard
            title={t("back")}
            variant="blank"
            icon={currentDirection === "ltr" ? previousIcon : nextIcon}
            iconSize={14}
        />}
      {/* Page title */}
      {title && <h3 className={classes.pageTitle}>{t(title)}</h3>}
      {children}
    </div>
  );
});

export default PageWrapper;
